import React from "react"
import CustomPageHeader from "../../fragments/CustomPageHeader"

export default function FinancierBatches({ children }) {
  return (
    <div>
      <CustomPageHeader icon='folder-open' text='Batches' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Batches/index.js